import Home from '../src/Home/index';
export default Home;
